import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Delete = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.125 6.375H19.875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6875 4.125H10.3125C10.0141 4.125 9.72798 4.24353 9.517 4.4545C9.30603 4.66548 9.1875 4.95163 9.1875 5.25V6.375H14.8125V5.25C14.8125 4.95163 14.694 4.66548 14.483 4.4545C14.272 4.24353 13.9859 4.125 13.6875 4.125Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3125 15.9375V10.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6875 15.9375V10.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1487 18.843C17.1254 19.1243 16.9972 19.3866 16.7895 19.5778C16.5818 19.7689 16.3098 19.875 16.0275 19.875H7.97325C7.69096 19.875 7.41898 19.7689 7.21128 19.5778C7.00358 19.3866 6.87534 19.1243 6.852 18.843L5.8125 6.375H18.1875L17.1487 18.843Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
